import React, { useEffect, useState } from "react";
import "./eventOfAssociation.scss";

import HeaderBar from "../../components/headerBar/HeaderBar";
import VoidSpace from "../../components/voidSpace/VoidSpace";
import SearchInput from "../../components/searchInput/SearchInput";
import CardEvent from "../../components/cardEvent/CardEvent";

import { useParams } from "react-router-dom";
import { setGlobalState } from "../../utils/state";
import { t } from "i18next";
import { isEmpty } from "../../utils/validation";
import { Button, Col, Row } from "react-bootstrap";
import {
  getEventsOfAssociationWS,
  getHistoryEventWS,
} from "./api/eventOfAssociationApi";
import CustomTabs from "../../components/customTabs/CustomTabs";

const EventOfAssociation = () => {
  const { id_association } = useParams();

  const [search, setSearch] = useState("");

  const [history, setHistory] = useState(false);

  const [events, setEvents] = useState([]);
  const [filteredEvents, setFilteredEvents] = useState([]);
  const [eventsHistory, setEventsHistory] = useState([]);
  const [filteredEventsHistory, setFilteredEventsHistory] = useState([]);

  const refreshContent = () => {
    getEventsOfAssociationWS({ id_association })
      .then((res) => {
        setEvents(res.events);
        setFilteredEvents(res.events);
      })
      .catch((err) => console.error(err));

    getHistoryEventWS({ id_association })
      .then((res) => {
        setEventsHistory(res);
        setFilteredEventsHistory(res);
      })
      .catch((err) => console.error(err));
  };

  useEffect(() => {
    setGlobalState("selectedIdBottomBar", 2);

    refreshContent();
  }, []);

  const searchFunction = () => {
    if (!isEmpty(search)) {
      setFilteredEvents(
        events.filter((event) =>
          event.name.toLowerCase().includes(search.toLowerCase())
        )
      );

      setFilteredEventsHistory(
        eventsHistory.filter((event) =>
          event.name.toLowerCase().includes(search.toLowerCase())
        )
      );
    } else {
      setFilteredEvents(events);
      setFilteredEventsHistory(eventsHistory);
    }
  };

  return (
    <>
      <HeaderBar
        title={t("list_event.title")}
        back={true}
        path={"/dashboard/" + id_association}
      />
      <div className="event-of-association-container container-responsive ">
        <SearchInput
          search={search}
          setSearch={setSearch}
          searchFunction={searchFunction}
        />
        <CustomTabs
          tabs={[
            {
              text: t("list_event.in_program"),
              onClick: () => setHistory(false),
              isSelected: !history,
            },
            {
              text: t("list_event.history"),
              onClick: () => setHistory(true),
              isSelected: history,
            },
          ]}
        />
        <div className="list-event">
          <Row sm={1} md={1} lg={2} xl={2} className="g-2">
            {history
              ? !isEmpty(filteredEventsHistory)
                ? filteredEventsHistory.map((item) => (
                    <Col
                      sm={12}
                      md={12}
                      lg={6}
                      xl={6}
                      key={item.id}
                      className="d-flex justify-content-center"
                    >
                      <CardEvent
                        id={item.id}
                        title={item.name}
                        associationName={item.name_association}
                        eventAddress={item.address}
                        photo={item.photo[0]}
                        startDatetime={item.start_date}
                        viewLike={false}
                        //idAssociation={id_association}
                        history={true}
                        refreshContent={refreshContent}
                      />
                    </Col>
                  ))
                : null
              : !isEmpty(filteredEvents)
              ? filteredEvents.map((item) => (
                  <Col
                    sm={12}
                    md={12}
                    lg={6}
                    xl={6}
                    key={item.id}
                    className="d-flex justify-content-center"
                  >
                    <CardEvent
                      id={item.id}
                      title={item.name}
                      associationName={item.name_association}
                      photo={item.photo[0]}
                      eventAddress={item.address}
                      startDatetime={item.start_date}
                      viewLike={false}
                      idAssociation={id_association}
                      history={false}
                      refreshContent={refreshContent}
                    />
                  </Col>
                ))
              : null}
          </Row>
          <VoidSpace />
        </div>
      </div>
    </>
  );
};

export default EventOfAssociation;
